import CheckboxDropdown from "@/components/common/checkbox-dropdown/checkbox-dropdown";
import { selectCategory } from "@/store/slices/category";
import { combineCategoryFilters } from "@/utils/combineCategoryFilters";
import { useRouter } from "next/router";
import React from "react";
import { useSelector } from "react-redux";

const OccasionFilter = ({ isSearch }: any) => {
  const router = useRouter();
  const categoryState = useSelector(selectCategory);

  const dropdownChange = (value: any[]) => {
    if (isSearch) {
      router.replace(
        {
          pathname: "/jewellery",
          query: {
            ...combineCategoryFilters({
              ...router.query,
              occasion: value,
            }),
            q: router.query.q,
            try_it_online: router.query.try_it_online,
          },
        },
        undefined,
        { shallow: true }
      );
      return;
    }
    router.replace(
      {
        pathname: "/jewellery/category/[category]",
        query: {
          category: categoryState.data?.slug,
          ...combineCategoryFilters({
            ...router.query,
            occasion: value,
          }),
        },
      },
      undefined,
      { shallow: true }
    );
  };

  return (
    <CheckboxDropdown
      label="OCCASION"
      items={categoryState?.facets
        ?.find((x: any) => x.key == "occasions")
        ?.data.map((v: any) => ({
          label: `${v.label} (${v.count})`,
          value: v.key,
        }))}
      onChange={dropdownChange}
      selected={
        typeof router.query.occasion == "string"
          ? [router.query.occasion]
          : router.query.occasion
      }
    />
  );
};

export default OccasionFilter;
